import "./Homepage.scss";

const Homepage = () => {
  return (
    <div className="homepage-container">
      <h1>Welcome to Marvel's Library</h1>
    </div>
  );
};

export default Homepage;
